<div class="card">
  <div class="card-header rounded-top bgi-size-cover" style="background-position: 100% 50%; background-image:url('assets/images/profile-head-bg.jpg'); height: 200px"></div>
  <div class="card-body mt-n19">
    <div class="m-0">
      <div class="d-flex flex-stack align-items-end pb-4 mt-n19">
        <div class="symbol symbol-125px symbol-lg-150px symbol-fixed position-relative mt-n3">
          @if (user.profile_image_url){
            <img [src]="user.profile_image_url" alt="image" class="border border-white border-4" style="border-radius: 20px" />
          } @else {
            <img src="assets/images/blank.png" alt="image" class="border border-white border-4" style="border-radius: 20px" />
          }
          <div class="position-absolute translate-middle bottom-0 start-100 ms-n1 mb-9 bg-success rounded-circle h-15px w-15px"></div>
        </div>
      </div>
      <div class="d-flex flex-stack flex-wrap align-items-end">
        <div class="d-flex flex-column">
          <div class="d-flex align-items-center mb-2">
            <a href="#" class="text-gray-800 text-hover-primary fs-2 fw-bolder me-1">{{ user.first_name }} {{user.last_name}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
